import { ObjectValues } from '../types';

export const themes = {
  block: 'block',
  'inline-block': 'inline-block',
} as const;

export const variants = {
  featured: 'featured',
  primary: 'primary',
} as const;

export type Flag = {
  text: string;
  theme?: ObjectValues<typeof themes>;
  variant?: ObjectValues<typeof variants>;
};
